import Layout from '@/pages/Layout';

export default [
    {
        path: '/operation',
        redirect: 'noredirect',
        component: Layout,
        name: 'operation',
        meta: {
            title: '运营中心',
            icon: 'el-icon-data-analysis'
        },
        children: [
            {
                path: 'tenantOperationTitle',
                name: 'tenantOperationTitle',
                id: 'tenantOperationTitle',
                meta: {
                    title: '企业运营分析',
                    icon: 'el-icon-s-operation',
                    color: '#0a75ec'
                },
                isOperation: true,
                isShow: false,
                isEntry: true,
                isNewMenu: true,
                isMenuWaterfall: false
            },
            {
                pId: 'tenantOperationTitle',
                path: 'processMonitor',
                component: () => import('@/pages/operation/ProcessMonitor'),
                // redirect: 'noredirect',
                name: 'processMonitor',
                id: 'operation/processMonitor',
                meta: {
                    title: '流程进度监控',
                    icon: 'iconfont icon-other-schedule bc-custom-menu',
                    color: '#67c23a'
                },
                isEntry: true,
                isSubMenu: true,
                isMenuWaterfall: true
            },
            // {
            //     path: 'warnMessage',
            //     component: () => import('@/pages/message/WarnMessage'),
            //     // redirect: 'noredirect',
            //     name: 'warnMessage',
            //     id: 'operation/warnMessage',
            //     meta: {
            //         title: '预警消息',
            //         icon: 'table'
            //     }
            // },
            {
                pId: 'tenantOperationTitle',
                path: 'processState',
                component: () => import('@/pages/operation/ProcessState'),
                // redirect: 'noredirect',
                name: 'processState',
                id: 'operation/processState',
                meta: {
                    title: '业务流程状态',
                    icon: 'iconfont icon-other-yewuzhuangtai bc-custom-menu',
                    color: '#e6a23c'
                },
                isEntry: true,
                isSubMenu: true,
                isMenuWaterfall: true
            },
            {
                pId: 'tenantOperationTitle',
                path: 'approvalState',
                component: () => import('@/pages/operation/ApprovalState'),
                // redirect: 'noredirect',
                name: 'approvalState',
                id: 'operation/approvalState',
                meta: {
                    title: '审批流程状态',
                    icon: 'iconfont icon-other-shenpiliu bc-custom-menu',
                    color: '#ff00ff'
                },
                isEntry: true,
                isSubMenu: true,
                isMenuWaterfall: true
            },
            {
                pId: 'tenantOperationTitle',
                path: 'userRealtimeState',
                component: () => import('@/pages/operation/UserRealtimeState'),
                // redirect: 'noredirect',
                name: 'userRealtimeState',
                id: 'operation/userRealtimeState',
                meta: {
                    title: '员工任务状态',
                    icon: 'iconfont icon-other-yuangong bc-custom-menu',
                    color: '#b02ef2'
                },
                isEntry: true,
                isSubMenu: true,
                isMenuWaterfall: true
            },
            {// 不在左侧菜单栏目展现该页面，而是从员工状态分布BI里和个人详情里出现
                path: 'userDetailState/:userId',
                component: () => import('@/pages/operation/UserDetailState'),
                // redirect: 'noredirect',
                name: 'userDetailState',
                id: 'operation/userDetailState/:userId',
                meta: {
                    title: '个人状态详情',
                    icon: 'table'
                },
                isMenuWaterfall: false
            },
            // {
            //     pId: 'tenantOperationTitle',
            //     path: 'timeGantt',
            //     component: () => import('@/pages/operation/TimeGantt'),
            //     // redirect: 'noredirect',
            //     name: 'timeGantt',
            //     id: 'operation/timeGantt',
            //     meta: {
            //         title: '项目状态分布',
            //         icon: 'table'
            //     },
            //     isSubMenu: true
            // },
            {
                pId: 'tenantOperationTitle',
                path: 'approvalTimeRatio',
                component: () => import('@/pages/operation/ApprovalTimeRatio'),
                // redirect: 'noredirect',
                name: 'approvalTimeRatio',
                id: 'operation/approvalTimeRatio',
                meta: {
                    title: '员工审批状态',
                    icon: 'iconfont icon-other-xiaoshuai bc-custom-menu',
                    color: '#0856f2'
                },
                isEntry: true,
                isSubMenu: true,
                isMenuWaterfall: true
            },
            {
                pId: 'tenantOperationTitle',
                path: 'closedLoop',
                component: () => import('@/pages/operation/ClosedLoop'),
                // redirect: 'noredirect',
                name: 'closedLoop',
                id: 'operation/closedLoop',
                meta: {
                    title: '闭环状态分布',
                    icon: 'iconfont icon-other-liucheng2 bc-custom-menu',
                    color: '#05eea0'
                },
                isEntry: true,
                isSubMenu: true,
                isMenuWaterfall: true
            },
            {
                path: 'planTimeGantt/:processInstanceId',
                component: () => import('@/pages/process/TimeConfig/TimeConfigGantt'),
                // redirect: 'noredirect',
                name: 'timeGantt',
                id: 'operation/planTimeGantt/:processInstanceId',
                meta: {
                    title: '项目管理甘特图',
                    icon: 'table'
                },
                isMenuWaterfall: false
            },
            {
                pId: 'tenantOperationTitle',
                path: 'processTimeTreeList',
                component: () => import('@/pages/operation/ProcessTimeTreeList'),
                // redirect: 'noredirect',
                name: 'processTimeTree',
                id: 'operation/processTimeTreeList',
                meta: {
                    title: '项目管理分布',
                    icon: 'iconfont icon-other-sp-baobiaotongji-xiangmuzongtiqingkuang bc-custom-menu',
                    color: '#0ab6f0'
                },
                isEntry: true,
                isSubMenu: true,
                isMenuWaterfall: true
            },
            {
                pId: 'tenantOperationTitle',
                path: 'processRecordList',
                component: () => import('@/pages/operation/ProcessRecordList'),
                // redirect: 'noredirect',
                name: 'processRecordList',
                id: 'operation/processRecordList',
                meta: {
                    title: '流程动态列表',
                    icon: 'iconfont icon-other-jurassic_process-sent- bc-custom-menu',
                    color: '#06b073'
                },
                isEntry: true,
                isSubMenu: true,
                isMenuWaterfall: true
            },
            {
                path: 'operationDesignTitle',
                name: 'operationDesignTitle',
                id: 'operationDesignTitle',
                meta: {
                    title: '运营设计',
                    icon: 'el-icon-s-operation'
                },
                sortOrder: 30,
                isDesign: true,
                isTitle: true,
                // isEntry: true,
                isShow: false,
                isMenuWaterfall: false
                // isSubMenu: true
            }
            // ,
            // {
            //     path: 'model/:formId/create',
            //     component: () => import('@/pages/application/ModelConfig/ModelAdd'),
            //     isShow: false,
            //     // redirect: 'noredirect',
            //     name: 'modelCreate',
            //     meta: {
            //         title: '创建模型',
            //         icon: 'table'
            //     }
            // }
        ]
    }
];



// WEBPACK FOOTER //
// ./src/router/modules/route-operation.js